import styled from '@emotion/styled';
import { useRef } from 'react';

// components
import PushItem from '../../../_organism/push/PushItem';
import Loading from '@components/_templates/Loading';

// hooks
import { useGetPushFetch } from '@hooks/fetch/usePushFetch';
import { useInfiniteScroll } from '@hooks/interaction/useInfiniteScroll';
import Alert from '@components/_atoms/Alert';
import { useTranslation } from 'next-i18next';
import LinkText from '@components/_atoms/Link/LinkText';
import { AlertIconType, TypoVariant } from '@constants/atoms';
import Typography from '@components/_atoms/Typography';
import { gray, primary } from '@styles/Colors';
import { mypageEditPath } from '@constants/routes/routes';
import ButtonCode from '@constants/log/buttonCode';

const Layout = styled.div``;

const PushItemListWrapper = styled.div`
  display: grid;
  row-gap: 24px;
`;

const ObserverSection = styled.div`
  margin-top: 24px;
`;

const AlertWrapper = styled.div`
  margin-bottom: 8px;

  display: flex;
  column-gap: 8px;
`;

const HighLightLink = styled.a`
  color: ${primary.blue};
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
`;

export default function PushContent() {
  const { getPushFetchData, isCustomLoading, getPushNextFetch } = useGetPushFetch(12);
  const pushData = getPushFetchData?.pages.flatMap((pageData) => pageData?.results);
  const EDIT_SALE_PRODUCT_ALARM = mypageEditPath.query({ type: 'material_alarm' });

  // Infinite Scroll
  const observerRef = useRef<HTMLDivElement>(null);
  useInfiniteScroll({ ref: observerRef, callback: getPushNextFetch });

  const { i18n } = useTranslation('user');
  const ko = i18n.language === 'ko';

  return (
    <Layout>
      {isCustomLoading && <Loading isLoading={isCustomLoading} />}
      <PushItemListWrapper>
        <Alert iconType={AlertIconType.QUESTION}>
          <Typography variant={TypoVariant.B4} color={gray.gray7}>
            {ko ? (
              <>
                내가 설정한 자재 알림은{' '}
                <HighLightLink href={EDIT_SALE_PRODUCT_ALARM} data-steelboso-id={ButtonCode.BTN_PRODUCT_NOTI}>
                  여기
                </HighLightLink>
                에서 확인해주세요.
              </>
            ) : (
              <>
                Check the material notifications you subscribed to{' '}
                <HighLightLink href={EDIT_SALE_PRODUCT_ALARM} data-steelboso-id={ButtonCode.BTN_PRODUCT_NOTI}>
                  here.
                </HighLightLink>
              </>
            )}
          </Typography>
        </Alert>

        {pushData?.map((item, idx) => (
          <PushItem data={item!} key={idx} />
        ))}
      </PushItemListWrapper>
      <ObserverSection ref={observerRef} />
    </Layout>
  );
}
